import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home\"><path d=\"M505.8 69.1L486.6 85C72 427.9 66 434.8 64 437l28.9 25.3 15.5 16.6c12.4-11.6 237.9-198.5 398-331l413.9 333 38.3-47.6L505.8 69.1z\" p-id=\"5458\" /><path d=\"M805.3 896.5H669V697.3H357.5v199.3H221.1V473.2h-61v484.4h706.3V473.2h-61v423.3zM418.5 758.3h189.4v138.2H418.5V758.3z\" p-id=\"5459\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol